import React from 'react';
import { Download } from 'lucide-react';
import './DownloadButton.css';

export interface DownloadButtonProps {
  /** Etiqueta para accesibilidad: "Descargar grabación de [nombre cámara]" */
  ariaLabel: string;
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
  /** Si true, el botón está visible (ej. padre con hover) */
  visible?: boolean;
  className?: string;
}

/**
 * Botón de descarga con hover reveal: zona mínima 44x44px, transición 200ms.
 * El padre debe tener posición relativa y mostrar el botón con .download-button-wrapper--visible en hover.
 */
export const DownloadButton: React.FC<DownloadButtonProps> = ({
  ariaLabel,
  onClick,
  disabled = false,
  visible = false,
  className = '',
}) => {
  return (
    <div
      className={`download-button-wrapper ${visible ? 'download-button-wrapper--visible' : ''} ${className}`}
      role="presentation"
    >
      <button
        type="button"
        className="download-button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        title="Descargar"
      >
        <Download size={20} aria-hidden />
      </button>
    </div>
  );
};
